(function(){
  function boot(){
    var overlay=document.getElementById('pmsd-overlay');
    var popup=document.getElementById('pmsd');
    if(!overlay||!popup) return;
    if(localStorage.getItem('pmsd-closed')) return;
    try{
      var seenAt=parseInt(localStorage.getItem('pmsd-seen-at')||'0',10);
      if(seenAt && (Date.now()-seenAt) < 7*24*3600*1000) return; // cooldown 7 dni jesli zignorowany
    }catch(e){}
    var excluded=['/cart','/checkout','/account','/pages/kontakt','/pages/regulamin','/pages/polityka','/pages/zwroty','/pages/terms','/pages/privacy','/pages/cookies'];
    var path=window.location.pathname.toLowerCase();
    for(var i=0;i<excluded.length;i++){ if(path.indexOf(excluded[i])!==-1) return; }

    var BOTTLE=((window.PawmateSnippetCfg||{}).pmsdBottle||'');
    var closeBtn=document.getElementById('pmsd-close');
    var stage=document.getElementById('pmsd-stage');
    var canvas=document.getElementById('pmsd-canvas');
    var sub=document.getElementById('pmsd-sub');
    var hint=document.getElementById('pmsd-hint');
    var claim=document.getElementById('pmsd-claim');
    var submitBtn=document.getElementById('pmsd-submit');
    var msg=document.getElementById('pmsd-msg');
    var revealBtn=document.getElementById('pmsd-reveal-btn');
    var shown=false, revealed=false, ctx=null, scratching=false;
    var dist=0, threshold=900, last=null, dpr=1, cw=0, ch=0;

    function show(){
      if(shown) return; shown=true;
      try{ localStorage.setItem('pmsd-seen-at', String(Date.now())); }catch(e){}
      overlay.style.display='block'; popup.style.display='block';
      requestAnimationFrame(function(){ overlay.classList.add('is-visible'); popup.classList.add('is-visible'); });
      document.body.style.overflow='hidden';
      requestAnimationFrame(initCanvas);
    }
    function hide(){
      overlay.classList.remove('is-visible'); popup.classList.remove('is-visible');
      setTimeout(function(){ overlay.style.display='none'; popup.style.display='none'; document.body.style.overflow=''; },300);
      localStorage.setItem('pmsd-closed','true');
    }
    function initCanvas(){
      if(!canvas||!canvas.getContext){ doReveal(); return; }
      var r=stage.getBoundingClientRect();
      if(!r.width){ setTimeout(initCanvas,120); return; }
      dpr=Math.min(window.devicePixelRatio||1,2);
      cw=Math.round(r.width*dpr); ch=Math.round(r.height*dpr);
      canvas.width=cw; canvas.height=ch;
      threshold=Math.max(700, r.width*3.2);
      ctx=canvas.getContext('2d');
      var img=new Image();
      img.crossOrigin='anonymous';
      img.onload=function(){
        try{
          ctx.clearRect(0,0,cw,ch);
          ctx.fillStyle='#cee8f6'; ctx.fillRect(0,0,cw,ch);
          var s=Math.min(cw/img.width, ch/img.height)*1.18;
          var dw=img.width*s, dh=img.height*s;
          ctx.drawImage(img,(cw-dw)/2,(ch-dh)/2,dw,dh);
        }catch(e){ paintFallback(r.width); }
      };
      img.onerror=function(){ paintFallback(r.width); };
      img.src=BOTTLE;
    }
    function paintFallback(w){
      try{
        var g=ctx.createLinearGradient(0,0,cw,ch); g.addColorStop(0,'#F5A623'); g.addColorStop(1,'#E07B00');
        ctx.fillStyle=g; ctx.fillRect(0,0,cw,ch);
        ctx.fillStyle='#fff'; ctx.textAlign='center'; ctx.textBaseline='middle';
        ctx.font='800 '+Math.round(w*0.13*dpr)+"px 'Plus Jakarta Sans',sans-serif";
        ctx.fillText('ZDRAP', cw/2, ch/2-w*0.08*dpr);
        ctx.fillText('MNIE', cw/2, ch/2+w*0.08*dpr);
      }catch(e){}
    }
    function pt(e){
      var r=canvas.getBoundingClientRect();
      var t=e.touches&&e.touches[0];
      return {x:((t?t.clientX:e.clientX)-r.left)*(cw/r.width), y:((t?t.clientY:e.clientY)-r.top)*(ch/r.height)};
    }
    function scratch(e){
      if(!scratching||!ctx||revealed) return;
      var p=pt(e);
      ctx.globalCompositeOperation='destination-out';
      ctx.lineWidth=44; ctx.lineCap='round'; ctx.lineJoin='round';
      if(last){ ctx.beginPath(); ctx.moveTo(last.x,last.y); ctx.lineTo(p.x,p.y); ctx.stroke(); dist+=Math.hypot(p.x-last.x,p.y-last.y)/dpr; }
      ctx.beginPath(); ctx.arc(p.x,p.y,22,0,Math.PI*2); ctx.fill();
      last=p;
      if(dist>threshold) doReveal();
    }
    function doReveal(){
      if(revealed) return; revealed=true;
      if(canvas){ canvas.style.opacity='0'; setTimeout(function(){ canvas.style.display='none'; },400); }
      if(hint) hint.style.display='none';
      if(revealBtn) revealBtn.style.display='none';
      if(sub) sub.textContent='Gratulacje! Odblokowales rabat -5%. Podaj e-mail, a wyslemy Ci kod.';
      if(claim) claim.style.display='flex';
      var em=claim?claim.querySelector('input[name="email"]'):null;
      if(em) setTimeout(function(){ try{em.focus();}catch(e){} },420);
    }
    if(canvas){
      canvas.addEventListener('mousedown',function(e){scratching=true;last=null;scratch(e);});
      window.addEventListener('mouseup',function(){scratching=false;last=null;});
      canvas.addEventListener('mousemove',scratch);
      canvas.addEventListener('touchstart',function(e){scratching=true;last=null;scratch(e);e.preventDefault();},{passive:false});
      canvas.addEventListener('touchmove',function(e){scratch(e);e.preventDefault();},{passive:false});
      canvas.addEventListener('touchend',function(){scratching=false;last=null;});
    }
    if(revealBtn){ revealBtn.style.display='inline'; revealBtn.addEventListener('click',doReveal); }

    function showMsg(html,type){ msg.innerHTML=html; msg.className='pmsd__msg pmsd__msg--'+type; msg.style.display='block'; }
    if(claim){
      claim.addEventListener('submit',async function(e){
        e.preventDefault();
        var email=claim.querySelector('input[name="email"]').value.trim();
        var consent=claim.querySelector('input[name="consent"]').checked;
        if(!email||!consent){ showMsg('Wpisz e-mail i zaznacz zgode.','err'); return; }
        submitBtn.disabled=true; var orig=submitBtn.textContent; submitBtn.textContent='Wysylam...';
        try{
          var res=await fetch('/apps/pawmate/newsletter/subscribe',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({shopId:''+((window.PawmateSnippetCfg||{}).shopDomain||'ycwb11-05.myshopify.com')+'',email:email,source:'scratch-popup'})});
          var data=await res.json();
          if(data.success){
            claim.querySelector('input[name="email"]').style.display='none';
            claim.querySelector('.pmsd__consent').style.display='none';
            submitBtn.style.display='none';
            showMsg(data.isNew?'Kod rabatowy <strong>-5%</strong> polecial na Twoj e-mail!':'Jestes juz z nami - sprawdz skrzynke, kod czeka.','ok');
            setTimeout(hide,5000);
          }else{ showMsg((data.error&&data.error.message)||'Wystapil blad. Sprobuj ponownie.','err'); submitBtn.disabled=false; submitBtn.textContent=orig; }
        }catch(err){ showMsg('Blad polaczenia. Sprobuj ponownie.','err'); submitBtn.disabled=false; submitBtn.textContent=orig; }
      });
    }
    closeBtn.addEventListener('click',hide);
    overlay.addEventListener('click',hide);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&shown) hide(); });
    setTimeout(show,8000);
  }
  if('requestIdleCallback' in window){ requestIdleCallback(boot,{timeout:3000}); } else { setTimeout(boot,1500); }
})();
